module.exports = __webpack_public_path__ + "static/media/03.b3075149.jpg";